import { Paper } from "@mui/material";
import styled from "styled-components";
import { theme } from 'styles/mui-config'

export const StyledContainer = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentWrapper = styled(Paper)`
  display: flex;
  padding:10px;
  padding-right:20px;
  border-radius:15px !important;
  justify-content: center;
  background:${theme.palette.primary.dark} !important;
  align-items: center;
  color:${theme.palette.primary.contrastText} !important;
`


